export { SuiTransitionModule, SuiTransition, Transition, TransitionDirection, TransitionController } from "./index";
//# sourceMappingURL=public.js.map


//////////////////
// WEBPACK FOOTER
// ../~/ng2-semantic-ui/dist/modules/transition/public.js
// module id = 1126
// module chunks = 0